export const ProductStylesMixins = {
  methods: {
    shortenDescription(description) {
      if (!description) {
        return '';
      }
      const trimmedString = description.substring(0, 100);
      return description.length > 70
        ? `${trimmedString.substring(
            0,
            Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
          )}...<span class="text-primary">more</span>`
        : description;
    },
  },
};
